import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useTerminateConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            key: "terminatedAt",
            name: t("terminated-date")
        }
    ], [t]);
}
